import * as actionTypes from './actionTypes'

const initialState = {
  userList: [],
  userDetails: {}
};

export default (state = initialState, { type, payload, isNewQuery }) => {
  switch (type) {
    case actionTypes.USER_LIST:
      return { ...state, userList: payload };
    case actionTypes.USER_DETAILS:
      return { ...state, userDetails: payload };
    case actionTypes.CLEAR_USER_DETAILS:
      return { ...state, userDetails: {} };
    case actionTypes.UPDATE_USER_STATE:
      return {
        ...state,
        userList: state.userList.map(el => el.user_id == payload.userId? { ...el, is_active: !el.is_active }: el)
      }
    case actionTypes.UPDATE_USER_ROLES:
      return {
        ...state,
        userList: state.userList.map(el => el.user_id == payload.userId? { ...el, roles: payload.roles }: el)
      }
    case actionTypes.DELETE_USER:
      return {
        ...state,
        userList: state.userList.filter(el => el.user_id != payload.userId)
      }
    default:
      return state
  }
}
